import { Translate } from '../../components/common/WithTranslate';
import { TLCode } from '../enums';
import { DayOfWeek } from '../enums/DateAndTime';

export const TranslateDayOfWeek = (dayOfWeek: DayOfWeek, translate: Translate): string => {
  switch (dayOfWeek) {
    case DayOfWeek.Monday:
      return translate(TLCode.Monday);
    case DayOfWeek.Tuesday:
      return translate(TLCode.Tuesday);
    case DayOfWeek.Wednesday:
      return translate(TLCode.Wednesday);
    case DayOfWeek.Thursday:
      return translate(TLCode.Thursday);
    case DayOfWeek.Friday:
      return translate(TLCode.Friday);
    case DayOfWeek.Saturday:
      return translate(TLCode.Saturday);
    case DayOfWeek.Sunday:
      return translate(TLCode.Sunday);
    default:
      break;
  }
  return '';
};
